import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

const MenuToggler = styled.div`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 30px;
  right: 20px;

  &:before {
    content: 'MENÚ';
    position: absolute;
    right: 100%;
    top: 0;
    font-size: 11px;
    margin-right: 10px;
  }

  ${breakpoint('desktop')`
    display: none;
  `}

  span {
    width: 100%;
    height: 2px;
    margin-bottom: 2px;
    background: black;
    display: block;
  }
`

class Boton extends React.Component {
  render() {
    return (
      <MenuToggler onClick={e => this.props.toggleMenuState(e)}>
        <span />
        <span />
        <span />
      </MenuToggler>
    )
  }
}

export default Boton
